// Путь внутри приложения с учётом базы сборки (vite --base): обычная сборка
// живёт в корне, экспериментальная - под подпутём (test.ecoway.kz/redesign/).
export const appPath = (path: string, base: string = import.meta.env.BASE_URL || "/"): string =>
  `${base.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
